export default "__VITE_ASSET__6u82CJ3W__"